import HomePage from "./pages/Home";
import Details from "./components/Details";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:foodname" element={<Details />} />
      </Routes>
    </>
  );
}

export default App;
